module.exports = __webpack_public_path__ + "static/media/logo_white.d024897f.svg";